<template>
  <div class="warp-content fx-c">
    <div class="fx fx-none warp-content-inner font12">
      <div class="fx fx-ps-center mr-12">
        <div class="fx-none mr-8">套餐版本:</div>
        <el-select v-model="listQuery.packageId" placeholder="请选择">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in versionOption" :key="index"></el-option>
        </el-select>
      </div>
      <div class="fx fx-ps-center mr-12">
        <div class="fx-none mr-8">所属行业:</div>
        <el-select v-model="listQuery.industry" placeholder="请选择">
          <el-option :label="item.title" :value="item.code" v-for="(item,index) in industryOption" :key="index"></el-option>
        </el-select>
      </div>
      <div class="fx fx-ps-center mr-12">
        <div class="fx-none mr-8">主营产品:</div>
        <el-input v-model="listQuery.mainProducts" placeholder="请输入主营产品"></el-input>
      </div>
      <div v-if="!isCaseuser" class="fx fx-ps-center mr-12">
        <div class="fx-none mr-8">激活时间:</div>
        <el-date-picker v-model="Time" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" />
      </div>
      <div class="fx fx-ps-center mr-12">
        <div class="fx-none mr-8">客户名称:</div>
        <el-input v-model="listQuery.companyName" placeholder="请输入客户名称"></el-input>
      </div>
      <el-button plain @click="clickResetSearch">重置</el-button>
      <el-button type="primary" @click="clickSearch">查询</el-button>
    </div>
    <div class="fx-full warp-content-inner mt-16">
      <div class="mb-16 fx-ps-center colorRed">*本站查询结果仅包含模板站客户，不包含定制站或者其他seo业务合作客户站点</div>
      <el-table :data="tableData" max-height="600" v-loading="loading">
        <el-table-column label="公司名" prop="companyName"></el-table-column>
        <el-table-column label="用户名" prop="loginName"></el-table-column>
        <el-table-column label="套餐版本" prop="packageName"></el-table-column>
        <el-table-column label="激活时间" prop="activeTime"></el-table-column>
        <el-table-column label="网站" prop="siteUrl"></el-table-column>
        <el-table-column label="所属行业" prop="industry">
          <template slot-scope="scope">
            {{getIndustry(scope.row.industry)}}
          </template>
        </el-table-column>
        <el-table-column label="主营产品" prop="mainProducts"></el-table-column>
      </el-table>
      <div class="fx mt-16">
        <div class="fx-full"></div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listQuery.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { onlineQuery, packagesQuery, industryQuery } from '@/api/index'
export default {
  data() {
    return {
      versionOption: [],
      industryOption: [],
      tableData: [],
      Time: [],
      listQuery: {
        industry: null,
        packageId: null,//套餐id
        mainProducts: "",//主营产品
        companyName: "",
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      loading: false
    }
  },
  computed: {
    getIndustry() {
      return s => {
        if (s) {
          return this.industryOption.find(v => v.code == s).title
        }
      }
    },
    isCaseuser() {
      return this.$store.state.userInfo.bloginName === "caseuser"
    },
  },
  created() {
    this.reqOnlineQuery()
    this.reqPackagesQuery()
    this.reqIndustryQuery()
  },
  methods: {
    reqPackagesQuery() {
      packagesQuery().then(res => {
        this.versionOption = res.data
      })
    },
    reqIndustryQuery() {
      industryQuery().then(res => {
        this.industryOption = res.data
      })
    },
    clickResetSearch() {
      this.Time = []
      this.listQuery = {
        industry: null,
        packageId: null,
        mainProducts: "",
        companyName: "",
        pageNum: 1,
        pageSize: 10
      },
        this.reqOnlineQuery()
    },
    clickSearch() {
      this.listQuery.pageNum = 1
      this.reqOnlineQuery()
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1
      this.listQuery.pageSize = val
      this.reqOnlineQuery()
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val
      this.reqOnlineQuery()
    },
    reqOnlineQuery() {
      this.loading = true
      const data = {
        activeStartTime: this.Time ? this.Time[0] : '',
        activeEndTime: this.Time ? this.Time[1] : ''
      }
      onlineQuery({ ...this.listQuery, ...data }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warp-content {
  height: 100%;
  padding: 12px;
  .warp-content-inner {
    background: #ffff;
    border-radius: 12px;
    padding: 12px;
  }
}
.font12 {
  font-size: 14px;
}
.colorRed {
  color: red;
  font-size: 12px;
}
</style>